<template>
  <div class="ContentBox">
    <div class="commonBox TopsBlack"><Tops :ishome="false" /></div>
    <el-carousel class="bannerBox" trigger="click" indicator-position="outside">
      <el-carousel-item v-for="item in 1" :key="item">
        <img src="@/assets/banner-2.png" />
      </el-carousel-item>
    </el-carousel>
    <!--  -->
    <PathBox />
    <!--  -->
    <router-view ></router-view>
    <template v-if="NavTypes == 0">
       <TypeOne />
    </template>
    <template v-if="NavTypes == 1">
       <TypeTwo />
    </template>
    <template v-if="NavTypes == 2">
       <TypeThree />
    </template>
    <template v-if="NavTypes == 3">
       <TypeFour />
    </template>
    <Footer />
  </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
import TypeOne from "@/components/PageView/TypeOne.vue";
import TypeTwo from "@/components/PageView/TypeTwo.vue";
import TypeThree from "@/components/PageView/TypeThree.vue";
import TypeFour from "@/components/PageView/TypeFour.vue";
export default {
  components: {
    Tops,
    Footer,
    PathBox,
    TypeOne,TypeTwo,TypeThree,TypeFour
  },
  data() {
    return {
      NavTypes: "",
      currentPage1: 5,
      MenuAct: "",
      CurrInt: "",
    };
  },
  mounted() {
    this.NavTypes = this.$route.query.type;
  },
  methods: {
    LookInfo(n) {
      this.$router.push("/ListArtInfo?id=" + n);
    },
    LookNavList(n) {
      this.CurrInt = n;
    },
    ChangeNavMenu(n) {
      this.MenuAct = n;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style lang="scss">
.el-timeline {
  padding: 0;
}
.bannerBox {
  height: 400px;
  .el-carousel__container {
    height: 100%;
  }
  .el-carousel__indicators--outside {
    position: absolute;
    bottom: 100px;
  }
  .el-carousel__item {
    img,
    .el-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
// ConetBox
.ConetBox {
  p {
    text-indent: 40px;
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 36px;
  }
  img {
    width: 100%;
  }
}
</style>